module.exports = __webpack_public_path__ + "img/graphic-bg-clouds-1.38396415.png";